"use strict";

var _marked =
/*#__PURE__*/
regeneratorRuntime.mark(getWidgetDataWithAdapter);

function _typeof(obj) { if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _effects = require("redux-saga/effects");

var _exposedHooks = require("../../exposed-hooks");

function getWidgetDataWithAdapter(editorState) {
  var _ref, adapter, columnsSet, configuration, value, category, _ref2, store, data;

  return regeneratorRuntime.wrap(function getWidgetDataWithAdapter$(_context) {
    while (1) {
      switch (_context.prev = _context.next) {
        case 0:
          _ref = (0, _exposedHooks.getLocalCache)(), adapter = _ref.adapter;

          columnsSet = function columnsSet(value, category) {
            return value && category && _typeof(value) === "object" && _typeof(category) === "object" && "name" in value && "name" in category;
          };

          configuration = editorState.configuration;
          value = configuration.value, category = configuration.category;

          if (!columnsSet(value, category)) {
            _context.next = 13;
            break;
          }

          _context.next = 7;
          return (0, _effects.select)();

        case 7:
          _ref2 = _context.sent;
          store = _ref2.widgetEditor;
          _context.next = 11;
          return adapter.requestData(store);

        case 11:
          data = _context.sent;
          return _context.abrupt("return", data);

        case 13:
          _context.next = 15;
          return [];

        case 15:
        case "end":
          return _context.stop();
      }
    }
  }, _marked);
}

var _default = getWidgetDataWithAdapter;
exports["default"] = _default;